export default {
      id: "video-play-outline-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#video-play-outline",
      toString: function () {
        return this.url;
      }
    }